import globals from '../globals'; 

export const getHeaders = (includeToken = false, isMultipart = false) => {
  const headers = {};

  // DO NOT set Content-Type when using FormData
  if (!isMultipart) {
    headers['Content-Type'] = 'application/json';
  }

  const businessId = localStorage.getItem('business_id');
  if (businessId) {
    headers['businessId'] = businessId;
  }

  if (includeToken) {
    const token = localStorage.getItem('authToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  // Include business_id in headers for authenticated requests
  if (includeToken && businessId) {
    headers['Business-Id'] = businessId;
  }
  return headers;
};

//Login
export const loginUser = async (email, password) => {
  const link = globals.baseUrl + '/login';

  const body = JSON.stringify({ email, password });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};


//Register
export const registerBusiness = async (data) => {
  const link = globals.baseUrl + '/register';

  const body = JSON.stringify({
    name: data.name,
    email: data.email,
    password: data.password,
    password_confirmation: data.confirm_password,
    user_type: "business"
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};


//Logout
export const logoutUser = async () => {
  const link = globals.baseUrl + '/logout';

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};


export const refreshToken = async () => {
  const link = globals.baseUrl + '/refresh';
  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(),
    credentials: 'include', // Include HttpOnly refresh token cookie
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to refresh token.');
  }

  return response;
};

// Store Roles & Permissions
export const StoreRolesPermissions = async (data) => {
  const link = globals.baseUrl + '/store-permission';

  const body = JSON.stringify({
    id: data.id,
    roles: data.name,
    permissions: data.permissions
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};

// All Roles & Permissions
export const AllPermissions = async () => {
  const link = globals.baseUrl + '/get-all-permission';

  const response = await fetch(link, {
    method: 'GET',
    headers: getHeaders(true),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};

// Delete Permissions
export const deletePermission = async (dataId) => {
  const link = globals.baseUrl + '/delete-permission';

  const body = JSON.stringify({
    id: dataId,
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};

// Get User
export const getUseData = async () => {
  const link = globals.baseUrl + '/get-user';

  const response = await fetch(link, {
    method: 'GET',
    headers: getHeaders(true),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};


